var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.content,{tag:"component",class:_vm.classes,style:(_vm.style),attrs:{"role":"text"}},[(_vm.original === false)?[_vm._v(_vm._s(_vm.text))]:_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }